import { FC } from '@Common/Services'

export const fetchOpenings = (agencyCode) => async () => {
  try {
    const data = await FC.service('public').get('calendarAvailability', { query: { agency: agencyCode } })
    return data
  } catch (err) {
    return null
  }
}

export const handleAppointmentSubmit = async (agencyId, range, formData, appointmentType, date, calendar) => {
  try {
    const payload = {
      agency: agencyId,
      calId: calendar,
      dayId: date,
      slotId: range,
      user: {
        ...formData,
        typeAppointment: appointmentType
      }
    }
    await FC.service('public').create(payload, { query: { action: 'requestAppointment' } })
  } catch (e) {
  }
}
